export function reloadPage() {
  window.location.reload()
}

export function replacePage(path) {
  window.location.replace(path)
}
